module.exports = __webpack_public_path__ + "static/img/dongtaishipei.6a36008c.png";